





























import { Locale } from 'vue-i18n';
import { Component, Vue } from 'vue-property-decorator';
import { Product } from '@/API';
import { isInHouseIP } from '@/appsync/service/MenuQueryService';
import { updateFavoriteStatus } from '@/appsync/service/MutateService';
import { fetchFavoriteMenuIdList } from '@/appsync/service/PortalFavoriteQueryService';
import { updateAccessedTimeStamp } from '@/appsync/service/PortalHistoryMenuMutationService';
import {
  fetchMenuList,
  getRoot,
} from '@/appsync/service/SiteMapMenusQueryService';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import { getUrlTarget } from '@/containers/globals/Util';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import SiteMapMenuList from '@/containers/templates/SiteMapMenuList.vue';
import { i18n } from '@/plugins/i18n/i18n';
import CommonStore, { commonModule } from '@/store/modules/CommonStore';
import { favoriteListModule } from '@/store/modules/FavoriteListStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  ID,
  UserInfo,
  MenuListItem,
  LoginInfo,
  TenantLandscape,
  UpdateFavoriteEvent,
  UpdateTimeStampQueryParam,
  ClickProductUrlEvent,
} from '@/types/type';
import { _BooleanEnum2boolean, getDisabledRoutes } from '@/utils/CommonUtils';
import { REL, PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    PortalAppBar,
    SiteMapMenuList,
    PageNotFound,
  },
})
export default class SiteMap extends Vue {
  private loading: boolean = true;
  private loadingMenus: boolean = true;
  private rootMenu: MenuListItem = getRoot();
  private isPortalEnabled: boolean = true;
  private hasSitemapPermission: boolean = false;

  private get pageTitle(): string {
    return i18n.tc('common.menu');
  }

  private get disableDueToNotInHouseDescription(): string {
    return i18n.tc('portal.disableDueToNotInHouse');
  }

  public async created(): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await refreshStores(loginInfo);

    // サイトマップ権限チェック
    const disabledRoutes = await getDisabledRoutes(
      loginInfo.tenant,
      loginInfo.landscape,
      loginInfo.loginName
    );

    this.isPortalEnabled = await getIsPortalEnabledStatus(
      loginInfo.tenant,
      loginInfo.landscape
    );

    // サイトマップの権限チェック
    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.sitemap)) {
      this.hasSitemapPermission = true;
    }

    this.loading = false;

    const favoriteIdList: ID[] = await fetchFavoriteMenuIdList(loginInfo);
    favoriteListModule.setUp(favoriteIdList);
    const menuItem: MenuListItem = await fetchMenuList(
      loginInfo,
      loginUserModule.userInfo.language,
      loginUserModule.productAdditionalQueryMap
    );
    const tenantLandscape: TenantLandscape = commonModule.tenantLandscape;

    const isInHouseIPCWS: boolean = await isInHouseIP(
      tenantLandscape.tenant,
      tenantLandscape.landscape,
      Product.CWS
    );
    const isInHouseIPCSR: boolean = await isInHouseIP(
      tenantLandscape.tenant,
      tenantLandscape.landscape,
      Product.CSR
    );

    if (menuItem.children) {
      const tempMenuItemChild: MenuListItem[] = menuItem.children;
      this.updateAvaibility(tempMenuItemChild, isInHouseIPCWS, isInHouseIPCSR);
    }
    this.rootMenu = menuItem;
    this.updateFavoriteStatus(favoriteIdList);
    this.loadingMenus = false;
  }

  private updateAvaibility(
    tempMenuItemChild: MenuListItem[],
    isInHouseIPCWS: boolean,
    isInHouseIPCSR: boolean
  ): void {
    for (let i = 0; i < tempMenuItemChild.length; i++) {
      const tempMenuItemChildChild: MenuListItem[] | undefined =
        tempMenuItemChild[i].children;
      if (
        tempMenuItemChildChild &&
        tempMenuItemChildChild !== undefined &&
        tempMenuItemChildChild.length > 0
      ) {
        this.updateAvaibility(
          tempMenuItemChildChild,
          isInHouseIPCWS,
          isInHouseIPCSR
        );
      } else {
        if (tempMenuItemChild[i].product === Product.CWS) {
          if (!isInHouseIPCWS && !tempMenuItemChild[i].canUseFromExtra) {
            tempMenuItemChild[i].available = false;
            tempMenuItemChild[
              i
            ].description = this.disableDueToNotInHouseDescription;
          }
        } else if (tempMenuItemChild[i].product === Product.CSR) {
          if (!isInHouseIPCSR && !tempMenuItemChild[i].canUseFromExtra) {
            tempMenuItemChild[i].available = false;
            tempMenuItemChild[
              i
            ].description = this.disableDueToNotInHouseDescription;
          }
        }
      }
    }
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get loginInfo(): LoginInfo {
    return commonModule.loginInfo;
  }

  private get menuListItem(): MenuListItem {
    return this.rootMenu;
  }

  private async updateFavorite(event: UpdateFavoriteEvent): Promise<void> {
    if (event.isFavorite) {
      favoriteListModule.add(event.id);
    } else {
      favoriteListModule.remove(event.id);
    }
    const menuIds = favoriteListModule.menuIdList;
    const loginInfo: LoginInfo = commonModule.loginInfo;
    await updateFavoriteStatus({ ...loginInfo, menuIds });
    this.updateFavoriteStatus(menuIds);
  }

  private updateFavoriteStatus(menuIds: ID[]) {
    const updateIfTarget = (menu: MenuListItem, targets: ID[]): void => {
      menu.isFavorite = targets.indexOf(menu.id) > -1;
      if (menu.children) {
        menu.children.forEach(child => updateIfTarget(child, targets));
      }
    };
    updateIfTarget(this.rootMenu, menuIds);
  }

  private async clickUrl(event: ClickProductUrlEvent): Promise<void> {
    const loginInfo: LoginInfo = commonModule.loginInfo;
    const { menuId, product, url } = event;
    const param: UpdateTimeStampQueryParam = { ...loginInfo, menuId, product };
    updateAccessedTimeStamp(param);
    window.open(url, getUrlTarget(product), REL);
  }
}
